module.exports = __webpack_public_path__ + "media/icons/icon-activities-green-d60a47e8.svg";